import { deleteRequest, get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getAlarmListFitler = async (): Promise<DataResponse<any>> => {
 
    const url = `${endpoints.getAlarmList}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
export const cancelAlarmItems = (data:any[])=>{
  const url = `${endpoints.cancelAlarmItem}`;
    const config = headers.content_type.application_json;
    return deleteRequest<DataResponse<any>>(url, data,config);
}
  